

import {defineComponent, inject} from 'vue'
import {useStore} from 'vuex'
import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  toastController
} from "@ionic/vue";

export default defineComponent({
  name: "Login",
  components: {
    IonBackButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
  },
  methods: {
    async handleClickSignIn() {
      try {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        const googleUser = await this.$gAuth.signIn()
        if (!googleUser) {
          return null
        }

        // Debug info
        console.debug("googleUser", googleUser);
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        this.user = googleUser.getBasicProfile().getEmail();
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        console.debug("getId", this.user);
        console.debug("getBasicProfile", googleUser.getBasicProfile());
        console.debug("getAuthResponse", googleUser.getAuthResponse());
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        console.debug(
            "getAuthResponse",
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            this.$gAuth.instance.currentUser.get().getAuthResponse()
        );

        // setting token
        const {id_token: idToken} = googleUser.getAuthResponse()
        this.idToken = idToken;
        this.store.dispatch('auth/backendAuth', idToken).then(() => {
          // show toast
          this.showToast("Login success", 'success');
          // return home
          this.$router.push('/profile');
        })
      } catch (error) {
        //on fail do something
        await this.showToast("Login failed: " + error, 'warning');
        console.error("Error authentication: ", error)
        return null
      }
    },
    async showToast(message, color) {
      const toast = await toastController
          .create({
            message: message,
            duration: 1500,
            color: color,
          })
      return toast.present();
    },
  },
  setup() {
    const store = useStore()
    const Vue3GoogleOauth = inject('Vue3GoogleOauth')
    return {
      Vue3GoogleOauth,
      store,
    }
  },
  data() {
    return {
      idToken: "",
      user: "",
    };
  },
})
